import { motion } from 'framer-motion'

function TabsAnimation({layoutId, bgCol}) {
  return (
    <motion.span
      layoutId={layoutId}
      className={`absolute inset-0 z-10 text-white ${bgCol ? bgCol : "bg-headPrimary"} font-semibold mix-blend-inherit rounded`}
      transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
    />
  )
}

export default TabsAnimation